// libs
import React, { memo } from 'react';

interface UserFilledProps {
  width?: number;
  height?: number;
  fill?: string;
  fillOpacity?: string;
  className?: string;
}

function UserFilled({
  width = 24,
  height = 24,
  fill = '#001325',
  fillOpacity = '0.64',
  className = '',
}: UserFilledProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity={fillOpacity}>
        <path
          d="M11.9999 11.0001C12.5102 11.0087 13.0169 10.9139 13.4895 10.7215C13.9622 10.529 14.3909 10.2428 14.7499 9.88012C15.1093 9.49429 15.3889 9.04121 15.5725 8.54695C15.7561 8.05269 15.8402 7.527 15.8199 7.00012V7.00012C15.8449 5.95168 15.457 4.9354 14.7399 4.17012C14.386 3.80012 13.9607 3.50568 13.4897 3.30459C13.0188 3.1035 12.512 2.99993 11.9999 3.00012V3.00012C11.4803 2.99076 10.9643 3.08924 10.4847 3.28934C10.005 3.48943 9.572 3.7868 9.21304 4.16268C8.85408 4.53855 8.57695 4.98476 8.39914 5.47313C8.22132 5.96151 8.14669 6.48145 8.17995 7.00012V7.10012C8.16514 7.60955 8.25322 8.11672 8.43894 8.59132C8.62465 9.06592 8.90417 9.49819 9.26079 9.86227C9.6174 10.2264 10.0438 10.5148 10.5144 10.7103C10.9851 10.9058 11.4903 11.0044 11.9999 11.0001V11.0001Z"
          fill={fill}
        />
        <path
          d="M19.21 21C19.3371 21.0008 19.4629 20.9747 19.5792 20.9233C19.6954 20.872 19.7995 20.7966 19.8845 20.7021C19.9695 20.6076 20.0336 20.4962 20.0724 20.3752C20.1113 20.2542 20.1241 20.1263 20.11 20C19.8686 18.019 18.9104 16.1949 17.4163 14.8718C15.9223 13.5488 13.9956 12.8184 12 12.8184C10.0043 12.8184 8.07766 13.5488 6.5836 14.8718C5.08954 16.1949 4.13139 18.019 3.88997 20C3.87585 20.1263 3.88864 20.2542 3.9275 20.3752C3.96636 20.4962 4.03041 20.6076 4.11543 20.7021C4.20046 20.7966 4.30453 20.872 4.42079 20.9233C4.53706 20.9747 4.66288 21.0008 4.78997 21H19.21Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export default memo(UserFilled);
